import React, { useEffect, useRef } from 'react';
import photo from '../../../media/img/companyInfo/default.png';
import LuisRodríguezGarcía from '../../../media/img/companyInfo/fotosEquipo/LuisRodríguezGarcía.jpg';
import AliciaRodriguez from '../../../media/img/companyInfo/fotosEquipo/AliciaRodriguez.jpg';
import './teamMember.scss';

const team = [
  {
    id: 1,
    name: 'Alicia Rodríguez Magro',
    photo: AliciaRodriguez,
    position: 'CEO y Fundadora',
    description:
      'Licenciada en Psicología Aplicada e investigadora de neuropsicología en la University of London. Fundadora de Wonderaly Innovations y creadora del Neurocinema Project.',
  },
  {
    id: 2,
    name: 'Luis Rodríguez',
    photo: LuisRodríguezGarcía,
    position: 'CBO',
    description:
      'Encargado de las oportunidades de negocio y alianzas clave para el desarrollo corporativo de Wonderaly Innovations.',
  },
];

const TeamMember = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="companyInfo__teamMember">
      <section className="teamMember">
        <div className="teamMember__header">
          <h1 className="teamMember__title content__title-backgroundDark">
            Nuestro equipo de Expertos
          </h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <p className="teamMember__subtitle content__text-title-backgroundDark">
            Un equipo interdisciplinar de neuropsicólogos, expertos en IA y
            profesionales del sector audiovisual, comprometidos con llevar la
            ciencia al servicio del arte.
          </p>
        </div>
        <div className="teamMember__grid">
          {team.map((person) => (
            <div
              key={person.id}
              className={`teamMember__card-container ${person.photo === photo ? 'flipped' : ''}`}
            >
              <div className="teamMember__card-flipper">
                <div className="teamMember__card-front">
                  <div className="teamMember__img-container">
                    <img
                      className="teamMember__img"
                      src={person.photo}
                      alt={person.name}
                    />
                  </div>
                </div>
                <div className="teamMember__card-back">
                  <p className="teamMember__position">{person.position}</p>
                  <h3 className="teamMember__name">{person.name}</h3>
                  <p className="teamMember__rol-descrition">
                    {person.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TeamMember;
